import styled from 'styled-components';

import type { CardProps } from '@/cms/Card';
import { CardRichTextRenderer } from '@/cms/Card/components/BaseCardType/RichTextEditor/CardRichTextRenderer';
import { Cta } from '@/cms/Card/components/CTA';
import type { ContentfulCardFragment } from '@/graphql/contentful/api';
import type { Maybe } from '@/lib/types';

const StayTunedCSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 6rem;
  margin-bottom: 2rem;
  font-family: ${({ theme }) => theme.fontFamilies.moderat};
  border-top: 2px solid #f4f4f4;
  padding: 40px 10px;
`;

const StayTunedContainer = styled.div`
  max-width: 490px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  text-align: center;
`;

const StayTunedTitle = styled.h3`
  font-family: ${({ theme }) => theme.fontFamilies.moderat};
  font-size: 2.25rem;
  letter-spacing: 0%;
  line-height: 100%;
`;

const StayTunedContent = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.moderat};
  font-size: 1.125rem;
`;

const stayTunedCTA = {
  ariaLabel: 'stay tuned submit',
  url: '',
  urlText: 'SUBMIT',
  urlType: 'arrowOutlineWhite',
  urlTrigger: {
    __typename: 'Event',
    type: 'Newsletter',
    sfId: null,
    campaignName: null,
    eventId: null,
    title: 'Newsletter',
    description: null,
  },
};

export const StayTunedComponent = ({
  data,
}: {
  data: ContentfulCardFragment;
}) => {
  return (
    <StayTunedCSection data-test-id='StayTunedSection'>
      <StayTunedContainer>
        <StayTunedTitle>STAY TUNED</StayTunedTitle>
        {data.cardText && (
          <StayTunedContent>
            <CardRichTextRenderer text={data.cardText} />
          </StayTunedContent>
        )}
        <Cta
          {...(stayTunedCTA as Pick<
            CardProps,
            | 'openUrlInNewTab'
            | 'onClickCta'
            | 'url'
            | 'urlText'
            | 'urlType'
            | 'urlTrigger'
          > & {
            ariaLabel?: string;
            fluid?: Maybe<boolean>;
            urlEventType?: string;
          })}
        />
      </StayTunedContainer>
    </StayTunedCSection>
  );
};
